import { render, staticRenderFns } from "./ServiceItems.vue?vue&type=template&id=abc58c5a&scoped=true"
import script from "./ServiceItems.vue?vue&type=script&lang=js"
export * from "./ServiceItems.vue?vue&type=script&lang=js"
import style0 from "./ServiceItems.vue?vue&type=style&index=0&id=abc58c5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc58c5a",
  null
  
)

export default component.exports